export default __webpack_public_path__ + "static/media/rights.0973e952.svg";